import type { JSX } from "react";
import { Box } from "@mui/material";
import { useExportStateContext } from "../contexts/ExportStateContext.ts";

export const ExportAction = (): JSX.Element => {
  const { setContainer } = useExportStateContext();
  // Report controls render here so export data stays with the active report.
  return <Box ref={setContainer} />;
};

export default ExportAction;
